// Tahmini bekleme süresini hesapla
export function calculateWaitTime(distance: string): string {
  const distanceNum = parseFloat(distance.replace(' km', ''));
  const baseWait = 5; // Minimum bekleme süresi
  const waitPerKm = 2; // Her km için ek bekleme
  const totalWait = Math.round(baseWait + (distanceNum * waitPerKm));
  return `${totalWait} dk`;
}